
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/viber",
      function () {
        return require("private-next-pages/viber/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/viber"])
      });
    }
  